import React, { useEffect } from "react";
import styles from "./modal.module.scss";

const Modal = ({
  show,
  onClose,
  title,
  children,
  containerClassName,
  overlayClassName,
  modalBodyClassName,
  modalHeaderClassName,
  isOutsideClickAllowed,
  showCloseIcon,
  isFullScreenPopupOnMobile = false,
}) => {

  useEffect(() => {
    if (show) {
      document.body.classList.add("hideScroll");
      return () => {
        document.body.classList.remove("hideScroll");
      };
    }
  }, [show]);

  return (
    <>
      {show ? (
        <div className={`${styles.modal} ${containerClassName}`}>
          <div
            className={`${styles.overlay} ${overlayClassName} ${
              isOutsideClickAllowed ? "" : styles.disabledOutsideClick
            }`}
            onClick={onClose}
          />
          <div className={`${styles.modalContent} ${modalBodyClassName}`}>
            <div
              className={`${styles.modalHeader} ${modalHeaderClassName}`}
              isFullScreenPopupOnMobile={String(isFullScreenPopupOnMobile)}
            >
              {title && <p>{title}</p>}
              {showCloseIcon && (
                <>
                  <i
                    className={`icon-close ${styles.close}`}
                    onClick={onClose}
                  />
                  <div className={styles.goBack} onClick={onClose}>
                    "goBack"
                  </div>
                </>
              )}
            </div>
            <div className={styles.modalBody}>{children}</div>
          </div>
        </div>
      ) : null}
    </>
  );
};

Modal.defaultProps = {
  containerClassName: "",
  overlayClassName: "",
  modalBodyClassName: "",
  modalHeaderClassName: "",
  isOutsideClickAllowed: true,
  showCloseIcon: true,
};

export default Modal;
